import React from 'react'
import Logo from '../assets/logo1.jpeg';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <footer className='bg-black pt-5 pb-2'>
        <div className='container'>

<img src={Logo} className='header-img rounded' alt='Footer Logo' />

<div className='row text-white'>

<div className='col-lg-4 col-12 my-2'>
  <p className='benefit-text mt-3'>About Us</p>
  <p className='para-text'>Shakti Tour offers unforgettable, affordable adventures with expert guides, scenic trails, and customized travel packages.</p>
</div>


<div className='col-lg-4 col-md-6 col-sm-6 col-6 my-2'>
  <p className='benefit-text mt-3'>Navigation</p>
<p><Link className='footer-text' >Home</Link></p>
<p><Link className='footer-text' >About</Link></p>
<p><Link className='footer-text' >Gallery</Link></p>
<p><Link className='footer-text' >Tour Packages</Link></p>
<p><Link className='footer-text' >Contact</Link></p>
</div>


<div className='col-lg-4 col-md-6 col-sm-6 col-6 my-2'>
  <p className='benefit-text mt-3'>Contact Us</p>
  <p className='footer-text'><i class="fa-solid fa-phone"></i> +91 9695889735</p>
  <p className='footer-text'><i class="fa-solid fa-envelope"></i> Shaktitours01@gmail.com</p>
  <p className='footer-text'><i class="fa-solid fa-location-dot"></i> Shivam paints, Myohol road, Manmohan Park Rd, near shivam paints, Old Katra, Prayagraj, Uttar Pradesh 211002</p>
</div>


</div>
{/* row ends */}

        </div>

<hr className='text-light' />

<p className='para-text text-light text-center'>Copyright &copy; Shakti Tours. All Rights Reserved. Developed By Dectwin Services Pvt Ltd</p>

      </footer>
    </>
  )
}

export default Footer
